import { Component, Input, ChangeDetectorRef, EventEmitter, ChangeDetectionStrategy, Output } from '@angular/core';
import { GridColumn, GridItem } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-desktop-column-edit',
  templateUrl: './grid-desktop-column-edit.component.html',
  styleUrls: [
    '../../../../assets/css/input.scss',
    '../../../../assets/css/select.scss',
    './grid-desktop-column-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridDesktopColumnEditComponent {
  @Input() column: GridColumn;
  @Input() item: GridItem;
  @Output() sdChange = new EventEmitter<{ column: GridColumn, item: GridItem, value: any }>();
  constructor(
    private ref: ChangeDetectorRef,
  ) { }

  onEditorChange = (column: GridColumn, item: GridItem, value: any) => {
    if (column.type !== 'children') {
      column.editor?.change?.(item, value);
      this.ref.detectChanges();
      this.sdChange.emit();
    }
  }

  onSearch = (searchValue: string, item: GridItem, column: GridColumn) => {
    item[column.field] = searchValue;
  }
}
